import { type ExcelCell } from 'venn-utils';
import { getTextThemeProvider } from 'venn-ui-kit';
import { compact } from 'lodash';

export const convertVdparNamesToExcel = (vdparNames: string[]): ExcelCell[][] => {
  const { vdparName, AppTitle } = getTextThemeProvider();
  return compact([
    [{ value: 'Name', style: { bold: true } }, { value: vdparName }],
    [
      { value: 'Note', style: { bold: true } },
      {
        value: `These returns may appear individually or within portfolios and benchmarks in this report. ${vdparName} use historical data and relationships to make estimates.`,
      },
    ],
    [
      { value: '' },
      {
        value: `These estimates will not always predict future results and have inherent limitations. This report includes ${vdparName}, which are returns modeled using cohort cash flow data and a public market proxy.`,
      },
    ],
    [{ value: '' }, { value: `Please see ${AppTitle} help center for more information.` }],
    [],
    [{ value: `${vdparName} Name`, style: { bold: true } }],
    ...compact(
      vdparNames.flatMap((vdparName: string): ExcelCell[][] | undefined => {
        if (!vdparName) {
          return undefined;
        }

        return [[{ value: vdparName }]];
      }),
    ),
  ]);
};
